import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[NoDblclick]'
})
export class NoDblclickDirective {

  @Input()
  activateButton: boolean;

  @Input()
  useExtendedDelay: boolean;

  constructor() { }

  @HostListener('click', ['$event'])
  onClickEvent(event) {
    let scope = this;
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);

    if (scope.activateButton !== undefined && scope.activateButton !== null && scope.activateButton === true) {

      if (this.useExtendedDelay) {
        setTimeout(function () {
          button.removeAttribute('disabled');
        }, 5000);
      } else {
        button.removeAttribute('disabled');
      }

    }

  }

}
